module.exports = __webpack_public_path__ + "static/img/best-director-3b-frances-and-martin.ae2de0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best-director-3b-frances-and-martin.jpg
// module id = 167
// module chunks = 0